import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { VoucherEmailModalComponent } from '../voucher-email-modal/voucher-email-modal.component';

@Component({
  selector: 'voucher-email-send',
  templateUrl: './voucher-email-send.component.html',
  styleUrls: ['./voucher-email-send.component.scss']
})
export class VoucherEmailSendComponent implements OnInit {

  @Input("email") email              = null;
  @Input("id") id                    = null;
  @Input("paymentLink") paymentLink  = false;

  constructor(  
    private dialog: MatDialog
  ){ }

  /**
   * 
   * Open
   * 
   */
  open(){

    this.dialog.open(VoucherEmailModalComponent,{
      width: "600px",
      data: {
        email: this.email,
        id: this.id,
        paymentLink: this.paymentLink
      }
    });

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
